import { isEmpty } from 'lodash';

import { useAppSelector } from '../../../App/redux/store';
import { getProcedureEventsState } from '../../../features/procedureEvent/reducer';
import RecentDemarchesContainer from './RecentDemarchesContainer';

function AdStudyRecentDemarches() {
  const { adStudyProcedureEvents }: { adStudyProcedureEvents: ProcedureEvents } =
    useAppSelector(getProcedureEventsState);

  return (
    <div className="my-folders-ad-creation-content-side-recent">
      <h4>Démarches récentes</h4>
      {isEmpty(adStudyProcedureEvents) ? (
        <div className="my-folders-ad-creation-side-line">Aucunes</div>
      ) : (
        <RecentDemarchesContainer procedureEvents={adStudyProcedureEvents} />
      )}
    </div>
  );
}

export default AdStudyRecentDemarches;
